import { baseConfig, RuntimeConfig } from 'config/config.types';
import { nonProductionColor } from 'theme/palette';

export const config: RuntimeConfig = {
  ...baseConfig,
  env: 'cloud',
  bannerColour: nonProductionColor,
};
